import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import React from "react";
import { connect } from "react-redux";
import { redirectTo } from "../../../util/redirect";
import { createGenericMastersQuery } from "../../../services/graphql/queries/masters";
import ReactModal from "../../Common/ReactModal";
import DisplayErrors from "../../Common/DisplayErrors";
import {
  SET_TIMEOUT_VALUE,
  ALPHANUMERIC_NAME_VALIDATION
} from "../../../constants/app-constants";
import { alphanumericAcceptanceValidation } from "../../../miscellaneous/misc";
import queryString from "query-string";
class GenericMasterAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      categoryCode: "",
      description: "",
      categoryCodeValid: true,
      categoryCodeMessage: "",
      descriptionValid: true,
      descriptionMessage: "",
      errors: [],
      genericMasterId: "",
      modalMessage: `${
        queryString.parse(this.props.location.search).name
      } Created Successfully`,
      reactModalVisible: false,
      isSubmitDisable: false
    };

    this.resetForm = this.resetForm.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }

  componentDidMount() {
    this.initialState = this.state;
  }
  closeModal() {
    this.setState({ reactModalVisible: false });
  }
  submitModal() {
    this.setState({ reactModalVisible: false });
    // redirectTo(
    //   "/genericmaster-profile?id=" +
    //     this.state.genericMasterId +
    //     "&name=" +
    //     this.props.router.query.name +
    //     "&masterFor=" +
    //     this.props.router.query.id
    // );

    this.props.history.push(
      "/genericmaster-profile?id=" +
        this.state.genericMasterId +
        "&name=" +
        queryString.parse(this.props.location.search).name +
        "&masterFor=" +
        queryString.parse(this.props.location.search).id
    );
  }
  handleValidation() {
    let fields = this.state;
    let formIsValid = true;
    let validationError = {
      descriptionValid: true,
      descriptionMessage: ""
    };
    if (!fields["description"]) {
      formIsValid = false;
      validationError.descriptionMessage = "*Enter a Valid description      ";
      validationError.descriptionValid = false;
    }
    if (
      fields["description"] &&
      !alphanumericAcceptanceValidation(
        fields["description"],
        ALPHANUMERIC_NAME_VALIDATION
      )
    ) {
      formIsValid = false;
      validationError.descriptionMessage =
        "Description must start with a character and can contain alphanumeric and &, _, /";
      validationError.descriptionValid = false;
    }
    this.setState(validationError);
    return formIsValid;
  }
  resetForm() {
    this.setState({ ...this.initialState, errors: [] });
  }
  submitForm(e) {
    if (this.handleValidation()) {
      this.setState({ errors: [], isSubmitDisable: true });
      console.log("Submit Values: ", this.state);
      this.setState({ loading: true });
      this.props.client
        .mutate({
          mutation: createGenericMastersQuery,
          variables: {
            description: this.state.description,
            masterFor: parseInt(
              queryString.parse(this.props.location.search).id
            )
          },
          fetchPolicy: "no-cache"
        })
        .then(result => {
          const genericMaster =
            result.data.createGenericMasters.genericMaster.Id;
          this.setState({ loading: false, error: "" });
          this.state.genericMasterId = genericMaster;
          if (this.state.genericMasterId !== "")
            this.setState({ reactModalVisible: true, isSubmitDisable: false });
          console.log("~~~data: ", this.state.genericMasterId);
        })
        .catch(error => {
          error.graphQLErrors.map(({ message }, i) => {
            this.setState({
              errors: [message],
              isSubmitDisable: false
            });
          });
          setTimeout(() => {
            this.setState({ errors: [], loading: false });
          }, SET_TIMEOUT_VALUE);
        });
    }
  }

  render() {
    const {
      description,
      errors,
      reactModalVisible,
      modalMessage,
      isSubmitDisable,
      descriptionValid,
      descriptionMessage
    } = this.state;
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          closeModal={this.closeModal}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={false}
        />
        <h1 className="heading m-b-25">{`${
          queryString.parse(this.props.location.search).name
        } Creation`}</h1>
        <div
          className="row"
          style={{
            display: errors.length === 0 ? "none" : "block"
          }}
        >
          <div className="col-md-6">
            <div className="alert alert-success" role="alert">
              <div className="row">
                <DisplayErrors errors={errors} />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="box-card">
              <div className="row">
                <div className="col-md-6 col-lg-6">
                  <div className="form-group">
                    <label>
                      Description<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      ref="description"
                      className={
                        descriptionValid
                          ? "form-control"
                          : "form-control is-invalid"
                      }
                      placeholder="Enter Description"
                      maxLength={65}
                      value={description}
                      onChange={e => {
                        this.setState({
                          description: e.target.value.toUpperCase()
                        });
                      }}
                    />
                    <div className="invalid-feedback">{descriptionMessage}</div>
                  </div>
                </div>
              </div>

              <div className="row m-t-45 m-b-15">
                <div className="col-md-12 col-lg-5">
                  <button
                    type="button"
                    className="btn btn-danger "
                    onClick={this.submitForm}
                    disabled={isSubmitDisable}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-light m-l-50"
                    onClick={this.resetForm}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect()(withApollo(GenericMasterAdd)));
